import { RCXLogger } from './RCXLogger';
import { LogLevel } from './transport/constants';

type LogDecoratorConfig = {
    exclude?: (string | symbol)[];
    logParams?: boolean;
};

const decoratedMap = new WeakMap();

const setMethodDecorated = (target: any, methodName: string | symbol) => {
    const decoratedMethods = decoratedMap.get(target) || [];
    decoratedMap.set(target, decoratedMethods.concat(methodName));
};

const isMethodDecorated = (target: any, methodName: string | symbol) => {
    const decoratedMethods = decoratedMap.get(target) || [];
    return decoratedMethods.includes(methodName);
};

export const log =
    (config: LogDecoratorConfig = {}) =>
    (target: any, methodName: string | symbol, descriptor: PropertyDescriptor) => {
        const originalMethod = descriptor.value;
        const clsName = target?.name || target?.constructor.name;
        descriptor.value = function (...args: any[]) {
            setTimeout(() => {
                const { logParams = false } = config;

                RCXLogger.getInstance().log({
                    level: LogLevel.INFO,
                    messageParts: [`[Info] ${clsName}.${String(methodName)} was called`, ...(logParams ? args : [])],
                });
            });
            return originalMethod.apply(this, args);
        };
        setMethodDecorated(target.constructor || target, methodName);
    };

export const logAll =
    (config: LogDecoratorConfig = {}) =>
    (target: any) => {
        Reflect.ownKeys(target.prototype).forEach((propertyName) => {
            const descriptor = Object.getOwnPropertyDescriptor(target.prototype, propertyName);

            const isMethod = typeof descriptor?.value === 'function' && propertyName !== 'constructor';
            if (!isMethod || config.exclude?.includes(propertyName) || isMethodDecorated(target, propertyName)) {
                return;
            }

            log(config)(target, propertyName, descriptor);
            Object.defineProperty(target.prototype, propertyName, descriptor);
        });
    };
